module.exports = __webpack_public_path__ + "media/error.9b3123b4.mp3";